import React from 'react'
import { routes } from '@sketch/modules-common'

import { useVersioning } from '../../../versioning'
import { DropdownLink } from './SymbolPathLinkDropdown.styles'
import { formatSymbolPath } from '../../utils'

interface SymbolPathLinkDropdownProps {
  paths: string[]
  prefix?: string
}

export const SymbolPathLinkDropdown = ({
  paths,
  prefix = '',
}: SymbolPathLinkDropdownProps) => {
  const { share } = useVersioning()

  return (
    <>
      {paths.map((path, index) => (
        <DropdownLink
          key={index}
          to={routes.CWV_SYMBOLS.create({
            shareID: share.identifier,
            query: {
              // encodeURIComponent was added to prevent paths with " " to be broken URLs
              g: encodeURIComponent(
                [
                  ...(prefix ? [prefix] : []),
                  ...paths.slice(0, index),
                  path,
                ].join('/')
              ),
            },
          })}
        >
          {formatSymbolPath(path, index)}
        </DropdownLink>
      ))}
    </>
  )
}
